import { render, staticRenderFns } from "./ConnectedUsers.vue?vue&type=template&id=87dc2336&scoped=true&"
import script from "./ConnectedUsers.vue?vue&type=script&lang=js&"
export * from "./ConnectedUsers.vue?vue&type=script&lang=js&"
import style0 from "./ConnectedUsers.vue?vue&type=style&index=0&id=87dc2336&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87dc2336",
  null
  
)

export default component.exports